/* eslint-disable @typescript-eslint/no-unsafe-return */
import { HttpErrorResponse, HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { catchError, concatMap, Observable, throwError } from 'rxjs';
import { inject } from '@angular/core';
import { AuthenticationService } from '../../core/services/authentication.service';
import { NavigationService } from '../../core/services/navigation.service';
import { isWhitelistHttpRequest, shouldRedirectToSignIn } from './whitelist';
import { PATHS } from '../models/paths';
import { DialogService } from '../../core/services/dialog.service';
import { StorageUploadStateService } from '../../core/services/storage-upload-state.service';

export function refreshTokenInterceptor(httpRequest: HttpRequest<unknown>, httpHandler: HttpHandlerFn): Observable<HttpEvent<unknown>> {
  const authenticationService = inject(AuthenticationService);
  const navigationService = inject(NavigationService);
  const dialogService = inject(DialogService);
  const storageUploadStateService = inject(StorageUploadStateService);

  return isWhitelistHttpRequest(httpRequest) ?
    httpHandler(httpRequest) :
    httpHandler(httpRequest)
      .pipe(
        catchError(error => {
          if (error instanceof HttpErrorResponse && (error.status === 401)) {
            return authenticationService.refreshSignIn()
              .pipe(
                concatMap(() => httpHandler(httpRequest)),
                catchError(() => {
                  if (shouldRedirectToSignIn(httpRequest)) {
                    void navigationService.navigate(PATHS.signIn());
                  }

                  return throwError(() => error);
                })
              );
          } else if (error.status === 403){
            storageUploadStateService.isFileUploadVisible.set(false);
            dialogService.showError('Non sei autorizzato ad eseguire questa operazione');
            return throwError(() => error);
          } else {
            return throwError(() => error);
          }
        })
      );
}
